import {
  UIStructuredOutput,
  Answer,
  ClarificationRequest,
  Refusal,
  Error as StructuredOutputError,
  AnswerElementsItem,
  Markdown,
  Table,
} from "../generated/core-api";

function tableToText(table: Table): string {
  const headerRow = table.headers.join("\t");
  const dataRows = table.rows.map((row) => row.join("\t")).join("\n");
  return `${headerRow}\n${dataRows}`;
}

function elementToText(element: AnswerElementsItem): string {
  switch (element.element_kind) {
    case "markdown":
      return (element as Markdown).markdown;
    case "table":
      return tableToText(element as Table);
    case "linegraph":
      // Skip graphs as they don't translate well to plain text
      return "";
    default:
      return "";
  }
}

function answerToText(answer: Answer): string {
  return answer.elements
    .map(elementToText)
    .filter((text) => text.length > 0)
    .join("\n\n");
}

function clarificationToText(clarification: ClarificationRequest): string {
  return `Clarification Needed: ${clarification.question}`;
}

function refusalToText(refusal: Refusal): string {
  return `Request Declined: ${refusal.reason}`;
}

function errorToText(error: StructuredOutputError): string {
  return `Error: ${error.reason}`;
}

export function structuredOutputToText(data: UIStructuredOutput): string {
  const response = data.response;

  if ("response_kind" in response) {
    switch (response.response_kind) {
      case "clarification_request":
        return clarificationToText(response as ClarificationRequest);
      case "refusal":
        return refusalToText(response as Refusal);
      case "error":
        return errorToText(response as StructuredOutputError);
    }
  }

  return answerToText(response as Answer);
}
